import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Alert
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const FixedWingSplitDuty = ({ baseline, handleChange }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Split Duty (Para 10)</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Alert severity="info" sx={{ mb: 3 }}>
          <Typography variant="body2">
            Split duty provisions based on D7J-J4-Fixed Wing.pdf Para 10. Applicable for Para 6.1.1 and 8.1 only.
          </Typography>
        </Alert>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={baseline.allowSplitDutyFixedWing}
                  onChange={(e) => handleChange('allowSplitDutyFixedWing', e.target.checked)}
                />
              }
              label="Allow Split Duty (Fixed Wing operations)"
            />
          </Grid>
          {baseline.allowSplitDutyFixedWing && (
            <>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Min Break Hours (For Extension)"
                  type="number"
                  value={baseline.splitDutyBreakMinHours}
                  onChange={(e) => handleChange('splitDutyBreakMinHours', parseFloat(e.target.value))}
                  inputProps={{ min: 3, max: 10, step: 0.5 }}
                  helperText="Para 10: Minimum 3 hrs for extension"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Max Break Hours (Before No Extension)"
                  type="number"
                  value={baseline.splitDutyBreakMaxHours}
                  onChange={(e) => handleChange('splitDutyBreakMaxHours', parseFloat(e.target.value))}
                  inputProps={{ min: 3, max: 12, step: 0.5 }}
                  helperText="Para 10: > 10 hrs = no extension"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Accommodation Required Hours"
                  type="number"
                  value={baseline.splitDutyAccommodationRequiredHoursFixedWing}
                  onChange={(e) => handleChange('splitDutyAccommodationRequiredHoursFixedWing', parseFloat(e.target.value))}
                  inputProps={{ min: 6, max: 10, step: 0.5 }}
                  helperText="Para 10.3: > 6 hrs or WOCL encroachment"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Max Segment Hours"
                  type="number"
                  value={baseline.maxSplitDutySegmentHoursFixedWing}
                  onChange={(e) => handleChange('maxSplitDutySegmentHoursFixedWing', parseFloat(e.target.value))}
                  inputProps={{ min: 1, max: 12, step: 0.5 }}
                  helperText="Para 10.4: Max 10 hrs per segment"
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={baseline.splitDutyBreakCountsAsFDP}
                      onChange={(e) => handleChange('splitDutyBreakCountsAsFDP', e.target.checked)}
                    />
                  }
                  label="Break Counts as FDP (Para 10.6)"
                />
              </Grid>
            </>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default FixedWingSplitDuty;
